import * as yup from 'yup';


export const IncomeDifferentialAnalysisBaseDtoIn = yup.object().shape({
    RaceId: yup.number()
        .required('Please select a race')
        .typeError('Please select a race')
        .nullable(),
    GenderId: yup.number()
        .required('Please select a gender')
        .typeError('Please select a gender')
        .nullable(),
    OccupationalLevelId: yup.number()
        .required('Please select an occupational level')
        .typeError('Please select an occupational level')
        .nullable(),
    Percentage: yup.number()
        .required('Please enter a percentage')
        .typeError('Please enter a percentage')
        .nullable(),
    RemunirationTypeId: yup.number()
        .required('Please select a remuneration type')
        .typeError('Please select a remuneration type')
        .nullable(),
});


export const IncomeDifferentialAnalysisSchema = yup.object().shape({
    topTile: IncomeDifferentialAnalysisBaseDtoIn.required(),
    bottomTile: IncomeDifferentialAnalysisBaseDtoIn.required()
});